import { PUSH_NOTIFICATIONS_ACTION } from "./fetchActions";
import getHandler from "../firebase/notifications/notificationHandlers";

/**
 * Redux middleware
 * @param {getState, dispatch}
 * @return {function(*): function(*=): *}
 */
export default ({ getState, dispatch }) => {
    const handler = getHandler({ getState, dispatch });
    return next => action => {
        const { type, data } = action;
        if (type === PUSH_NOTIFICATIONS_ACTION) {
            handler(data)
        }
        return next(action)
    }
}
